const brandAdapters = {
  transformForAPI: (data) => {
    return data;
  },
  transformForBO: (data) => {
    return data;
  },
};

export default brandAdapters;
